module.exports = __webpack_public_path__ + "assets/img/1464.ba752238.png";